import React from 'react'
import { FLAG_OPTIONS } from '../../utils/flagOptions'

/**
 * BulkFlagSelectorModal - modal para aplicar una bandera a multiples contactos.
 * Usa la lista canonica FLAG_OPTIONS de utils/flagOptions para garantizar
 * que los iconos sean identicos al dropdown individual de ContactsTable.
 *
 * Props:
 *   open:      boolean
 *   onClose:   () => void
 *   onConfirm: (banderaId: string | null) => void
 *   count:     number  (cantidad de contactos seleccionados, para el header)
 */
export default function BulkFlagSelectorModal({ open, onClose, onConfirm, count }) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center">
      <div className="bg-white dark:bg-surface-dark rounded-lg shadow-2xl max-w-md w-full mx-4">
        <div className="bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-4 rounded-t-lg">
          <h3 className="text-lg font-semibold">Aplicar FLAG a {count} contacto{count !== 1 ? 's' : ''}</h3>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-3 gap-2">
            {FLAG_OPTIONS.map(opt => (
              <button
                key={opt.key}
                onClick={() => onConfirm(opt.key)}
                className="flex flex-col items-center justify-center p-3 rounded-lg border-2 border-gray-200 dark:border-gray-700 hover:border-amber-400 dark:hover:border-amber-500 hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-colors"
                type="button"
                title={opt.label}
              >
                <span className="flex items-center justify-center" style={{ minHeight: '2rem' }}>
                  {opt.render('lg')}
                </span>
                <span className="text-xs mt-1 text-gray-700 dark:text-gray-300">{opt.label}</span>
              </button>
            ))}
            <button
              onClick={() => onConfirm(null)}
              className="flex flex-col items-center justify-center p-3 rounded-lg border-2 border-gray-200 dark:border-gray-700 hover:border-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
              type="button"
              title="Quitar bandera"
            >
              <span className="text-2xl text-gray-400" style={{ minHeight: '2rem', display: 'flex', alignItems: 'center' }}>&#x2715;</span>
              <span className="text-xs mt-1 text-gray-500">Sin bandera</span>
            </button>
          </div>
        </div>
        <div className="px-6 pb-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 dark:text-gray-200 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600"
            type="button"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  )
}
